export default __webpack_public_path__ + "static/media/person-3.3cea5265.png";